import { StrictMode } from "react"
import type { ComponentType } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"

import App from "./App.tsx"
import "./index.css"
import { DailyCalculatorProvider } from "@/features/daily"
import { LanguageProvider } from "@/shared/providers"

async function bootstrap() {
  const container = document.getElementById("root")

  if (!container) {
    throw new Error("Unable to find #root element")
  }

  const root = createRoot(container)

  let LanguageSwitcher: ComponentType | null = null

  if (import.meta.env.DEV) {
    const module = await import("@/shared/components/LanguageSwitcher.tsx")
    LanguageSwitcher = module.default
  }

  root.render(
    <StrictMode>
      <LanguageProvider>
        <BrowserRouter>
          <App />
          {LanguageSwitcher ? <LanguageSwitcher /> : null}
        </BrowserRouter>
      </LanguageProvider>
    </StrictMode>,
  )
}

void bootstrap()
